export const NavigationTitle = {
  Auctions: 'Auctions',
  Artworks: 'Artworks',
  Selections: 'Selections',
  Artists: 'Artists',
  Curators: 'Curators',
  FAQ: 'FAQ',
  About: 'About Us',
  News: 'News',
  Contacts: 'Contacts',
  BehindTheScenes: 'Process',
} as const;

const NavigationLink = {
  Auctions: 'auctions',
  Artworks: 'artworks',
  Selections: 'selections',
  Artists: 'artists',
  Curators: 'curators',
  FAQ: 'faq',
  About: 'about-us',
  News: 'news',
  Contacts: 'contact-us',
  BehindTheScenes: 'process',
} as const;

export const navigationLinks = [
  {
    title: NavigationTitle.Auctions,
    link: NavigationLink.Auctions,
  },
  {
    title: NavigationTitle.Artworks,
    link: NavigationLink.Artworks,
  },
  {
    title: NavigationTitle.Selections,
    link: NavigationLink.Selections,
  },
  {
    title: NavigationTitle.Artists,
    link: NavigationLink.Artists,
  },
  {
    title: NavigationTitle.Curators,
    link: NavigationLink.Curators,
  },
  {
    title: NavigationTitle.About,
    link: NavigationLink.About,
  },
  {
    title: NavigationTitle.BehindTheScenes,
    link: NavigationLink.BehindTheScenes,
  },
  {
    title: NavigationTitle.News,
    link: NavigationLink.News,
  },
  {
    title: NavigationTitle.FAQ,
    link: NavigationLink.FAQ,
  },
  {
    title: NavigationTitle.Contacts,
    link: NavigationLink.Contacts,
  },
] as const;
